import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/card";
import Spinner from "@/atomic/atoms/Spinner";
import Modal from "@/atomic/atoms/Modal";
import useI18n from "@/hooks/useI18n";
import { useThemeContext } from "@/contexts/ThemeContext";

export default function RechargeCardView({
  isLoading,
  error,
  goBack,
  payment,
  dismissError,
}: PropsView) {
  const { t } = useI18n();
  const { themeName } = useThemeContext();
  const title = themeName === 'zapay' ? 'Pedágio' : t("pages:checkout:payment");

  return (
    <div className="h-full flex flex-col">
      <Header
        title={title}
        hasLeftButton
        goBack={goBack}
      />

      <main className="flex-1 bg-white" />

      {isLoading && <Spinner />}

      {error && (
        <Modal
          title={t("pages:checkout:errors:chargeFailedTitle")}
          message={t("pages:checkout:errors:chargeFailedMessage")}
          action={payment}
          actionMessage={t("pages:checkout:errors:tryAgain")}
          actionSecond={dismissError}
          actionSecondMessage={t("common:cancel")}
          actionClose={dismissError}
        />
      )}
    </div>
  );
}
